import React from 'react';
import MaterialIcon from '../ui/MaterialIcon';

const AMENITY_ICONS = {
  wifi: 'wifi',
  restaurant: 'restaurant',
  power: 'power',
  movie: 'movie',
  airline_seat_recline_extra: 'airline_seat_recline_extra',
};

function FlightResultCard({ flight, savings, onSelect }) {
  return (
    <button
      onClick={() => onSelect && onSelect(flight)}
      className="w-full text-left bg-white rounded-2xl p-4 shadow-card border border-outline-variant/8 hover:shadow-card-hover hover:border-outline-variant/15 transition-all active:scale-[0.99]"
    >
      {/* Airline Header */}
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2.5">
          {/* Airline Logo Placeholder */}
          <div className="w-9 h-9 rounded-xl bg-primary-light/50 flex items-center justify-center">
            <span className="text-xs font-bold text-primary">{flight.airlineCode}</span>
          </div>
          <div>
            <p className="text-sm font-semibold text-on-surface">{flight.airline}</p>
            <p className="text-xs text-on-surface-variant">{flight.flightNumber}</p>
          </div>
        </div>
        {/* Price */}
        <div className="text-right">
          <p className="text-lg font-bold text-primary">${Math.round(flight.price)}</p>
          <p className="text-xs text-on-surface-variant">per person</p>
          {savings > 0 && (
            <p className="text-[11px] font-semibold text-success mt-0.5">
              Save up to ${Math.round(savings)}
            </p>
          )}
        </div>
      </div>

      {/* Route Timeline */}
      <div className="flex items-center gap-3 py-3">
        {/* Departure */}
        <div className="text-left">
          <p className="text-xl font-bold text-on-surface">{flight.departure.time}</p>
          <p className="text-xs font-medium text-on-surface-variant mt-0.5">{flight.departure.airport}</p>
        </div>

        {/* Route Line Visualization */}
        <div className="flex-1 flex flex-col items-center gap-1">
          <p className="text-xs text-on-surface-variant">{flight.duration}</p>
          <div className="w-full flex items-center gap-0">
            <div className="w-2 h-2 rounded-full bg-primary" />
            <div className="flex-1 h-px bg-outline-variant relative">
              {flight.stops > 0 && (
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full bg-outline-variant" />
              )}
            </div>
            <div className="w-2 h-2 rounded-full bg-primary" />
          </div>
          <p className={`text-xs font-medium ${
            flight.stops === 0 ? 'text-success' : 'text-on-surface-variant'
          }`}>
            {flight.stopsInfo}
          </p>
        </div>

        {/* Arrival */}
        <div className="text-right">
          <p className="text-xl font-bold text-on-surface">{flight.arrival.time}</p>
          <p className="text-xs font-medium text-on-surface-variant mt-0.5">{flight.arrival.airport}</p>
        </div>
      </div>

      {/* Amenities Row */}
      <div className="flex items-center gap-2 pt-2 border-t border-outline-variant/20">
        <div className="flex items-center gap-1.5">
          {flight.amenities.map((amenity) => (
            <span
              key={amenity}
              className="w-7 h-7 rounded-lg bg-surface-container flex items-center justify-center"
            >
              <MaterialIcon
                name={AMENITY_ICONS[amenity] || amenity}
                size={16}
                className="text-on-surface-variant"
              />
            </span>
          ))}
        </div>
        <div className="ml-auto">
          <span className="text-[11px] font-medium text-primary bg-primary-light/50 px-2.5 py-1 rounded-full">
            {flight.cabin}
          </span>
        </div>
      </div>
    </button>
  );
}

export default FlightResultCard;
